export default __webpack_public_path__ + "static/ProximaNova-Bold-01d57c14c86107aa9049959823219cd0.woff2";